import { render, staticRenderFns } from "./PortalDocumentosView.vue?vue&type=template&id=c5c6fab2&"
import script from "./PortalDocumentosView.vue?vue&type=script&lang=js&"
export * from "./PortalDocumentosView.vue?vue&type=script&lang=js&"
import style0 from "./PortalDocumentosView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports